import React from 'react'
import Moment from 'react-moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRupeeSign } from '@fortawesome/free-solid-svg-icons'
import { PrintHelpers } from './index'
import {SendGridWebHookViewer} from "../SendGridWebHookViwer/SendGridWebHookViewer";
var Barcode = require('react-barcode')
export const Header = (props) => {
  let { organization, legend } = props
  return (
    <div className="page-header mt-3 mb-3 text-center">
      <h2 className="mb-0">{organization.name}</h2>
      <h6>
        <strong>{legend}</strong>
      </h6>
    </div>
  )
}
export const Label = (props) => {
  let { value } = props
  return (
    <strong>
      <label>{value}: </label>
    </strong>
  )
}
export const Strong = (props) => {
  let { value } = props
  return (
    <strong>
      <label>{value}</label>
    </strong>
  )
}
export const SectionHeadingLabel = (props) => {
  let { value } = props
  return (
    <strong>
      <label>{value}</label>
    </strong>
  )
}

export const Currency = (props) => {
  let { value } = props
  return (
    <strong>
      {value} <FontAwesomeIcon icon={faRupeeSign} />
    </strong>
  )
}
export const EaseOnBarcode = (props) => {
  let { value } = props
  return (
    <Barcode
      width={2}
      height={25}
      format={'CODE128'}
      displayValue={true}
      background="#ffffff"
      lineColor="#000000"
      value={value}
    />
  )
}
export const TimeStamp = (props) => {
  let { value, label } = props
  return (
    <div>
      <Label value={label} />
      <Moment format="DD-MM-YYYY hh:mm A" local>
        {value}
      </Moment>
    </div>
  )
}
export const Device = (props) => {
  let { value, label } = props

  return (
    <div className="printsection">
      <h5>
        <SectionHeadingLabel value={label} />
      </h5>
      <p>
        <Label value={'Serial Number'} />
        {value.serial_number}
      </p>
      {value.alternate_device_id ? (
        <p>
          <Label value={'IMEI Number'} />
          {value.alternate_device_id}
        </p>
      ) : (
        ''
      )}
      <p>
        <Label value={'Product'} />
        {value.product_name}
      </p>
      <p>
        <Label value={'Configuration'} />
        {value.configuration}
      </p>
      {(value.inward_gsx_service_type &&
        <p>
          <Label value={'Coverage Status '} />
          { value.inward_gsx_service_type}
        </p>
      )}
    </div>
  )
}
export const Organization = (props) => {
  let { value, label } = props
  return (
    <div className="printsection">
      <h5>
        <SectionHeadingLabel value={label} />
      </h5>
      <p>
        <Label className="clearfix" value={'Name'} />
        {value.name}
      </p>
      <p>
        <Label value={'Address'} />
        {value.address}
        {value.city}-{value.pin_code}
      </p>
      <p>
        <Label value={'Email'} />
        {value.email}
      </p>
      <p>
        <Label value={'Contact Number'} />
        {value.contact_number}
      </p>
      <p>
        <Label value={'Timing'} />
        {value.timings}
      </p>
    </div>
  )
}
export const Customer = (props) => {
  let { value, label } = props
  const address = `${value.address_line_1} ${value.address_line_2 || ""} ${value.street||""} ${value.city} ${value.state} ${value.country} ${value.pin_code}`
  return (
    <div className="printsection">
      <h5>
        <SectionHeadingLabel value={label} />
      </h5>
      <p>
        <Label className="clearfix" value={'Name'} />
        {value.first_name} {value.last_name}
      </p>


      {value.company_name && (
        <p>
          <Label className="clearfix" value={'Company'} />
          {value.company_name}
        </p>
      )}
      <p>
        <Label value="Address" />
        {address}
      </p>
      <p>
        <Label value="Email" />
        {value.email}<SendGridWebHookViewer
          email={value.email}></SendGridWebHookViewer>
      </p>
      <p>
        <Label value="Contact Number" />
        {value.contact_number}, {value.alternate_contact_number}
      </p>
      <p className="d-print-none">
        <Label value="Customer Type" />
        {value.customer_type}
      </p>
    </div>
  )
}
export const PrintText = (props) => {
  let { value, label } = props
  return (
    <div style={{ wordWrap: 'break-word' }} className="printsection">
      {label ? (
        <p>
          <Label className="clearfix" value={label} />
        </p>
      ) : (
        ''
      )}
      <p
        className="break-word"
        style={{ display: 'inline-block', wordWrap: 'break-word' }}
      >
        {value}
      </p>
    </div>
  )
}
export const InlineText = (props) => {
  let { value, label, isCurrency } = props
  return (
    <div>
      <p
        className="break-word"
        style={{ display: 'inline-block', wordWrap: 'break-word' }}
      >
        {label ? <Label className="clearfix" value={label} /> : ''}
        {isCurrency ? <PrintHelpers.Currency value={value} /> : value}
      </p>
    </div>
  )
}
export const SLA = (props) => {
  let { value, label } = props
  return (
    <div>
      <p>
        <SectionHeadingLabel className="clearfix" value={label} />
      </p>
      <ul>
        {value.terms &&
          value.terms.map((item, index) => {
            return (
              <li className="text-justify" key={index}>
                <p
                  className="break-word"
                  style={{ padding: '5px', wordWrap: 'break-word' }}
                >
                  {item.statement}
                </p>
              </li>
            )
          })}
      </ul>
    </div>
  )
}

export const Terms = (props) => {
  let { value, label } = props
  return (
    <div>
      <p>
        <SectionHeadingLabel className="clearfix" value={label} />
      </p>
      <ul>
        {value &&
          value.map((item, index) => {
            return (
              <li className="text-justify" key={index}>
                <p
                  className="break-word"
                  style={{ padding: '5px', wordWrap: 'break-word' }}
                >
                  {item}
                </p>
              </li>
            )
          })}
      </ul>
    </div>
  )
}
export const DevicePartReport = (props) => {
  let { reports, label } = props
  return (
    <div>
      <p>
        <SectionHeadingLabel className="clearfix" value={label} />
      </p>
      <table className="table table-borderless table-sm">
        <thead>
          <tr>
            <th> Part </th>
            <th> Status </th>
          </tr>
        </thead>
        <tbody>
          {reports &&
            Object.keys(reports).map((key, index) => {
              return (
                <tr key={index}>
                  <th> {key} </th>
                  <td> {reports[key]} </td>
                </tr>
              )
            })}
        </tbody>
      </table>
    </div>
  )
}
export const CustomerFeedback = (props) => {
  let { reports, label } = props
  const key_to_text = (val) => {
    val = val.replaceAll('_', ' ')
    val = val.charAt(0).toUpperCase() + val.slice(1)
    return val
  }

  return (
    <div>
      <p>
        <SectionHeadingLabel className="clearfix" value={label} />
      </p>
      <table className="table table-borderless table-sm">
        <thead>
          <tr>
            <th> Parameter </th>
            <th> Response </th>
          </tr>
        </thead>
        <tbody>
          {reports &&
            Object.keys(reports).map((key, index) => {
              return (
                <tr key={index}>
                  <th> {key_to_text(key)} </th>
                  <td> {reports[key]} </td>
                </tr>
              )
            })}
        </tbody>
      </table>
    </div>
  )
}
export const OrderLineTable = (props) => {
  let { order_lines, label, serializable_order_lines } = props
  return (
    <div>
      <p>
        <SectionHeadingLabel className="clearfix" value={label} />
      </p>
      <table className="table table-borderless table-sm">
        <thead>
          <tr>
            <th>Part Number</th>
            <th>Description</th>
            <th>KBB Number</th>
            <th>KGB Number</th>
            <th>Quantity</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {order_lines.map((item, index) => {
            return (
              <tr key={index}>
                <td>{item.inventory_item_part_number || 'N/A'}</td>
                <td>{item.inventory_item_description}</td>
                <td>{item.kbb_serial_number}</td>
                <td>{item.inventory_item_serial_number}</td>
                <td>{item.quantity}</td>

                <td>
                  <Currency value={item.amount} />
                </td>
              </tr>
            )
          })}
          {serializable_order_lines.map((item, index) => {
            return (
              <tr key={index}>
                <td>{item.part_number}</td>
                <td>{item.description}</td>
                <td>{'N/A'}</td>
                <td>{'N/A'}</td>
                <td>{item.quantity}</td>

                <td>
                  <Currency value={item.amount} />
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export const Signature = ({ signature }) => {
  if (!signature) {
    return <div style={{ padding: '50px' }}></div>
  }
  return <img alt="signature_img" height="100px" width="100%" src={signature} />
}
